import { render, staticRenderFns } from "./BuypassSettingsInfoModal.vue?vue&type=template&id=1543736f"
import script from "./BuypassSettingsInfoModal.vue?vue&type=script&lang=js"
export * from "./BuypassSettingsInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports